/**
 * Created by Administrador on 30/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('quantityService', quantityService)

    quantityService.$inject = ['$http', 'CONFIG', 'messageService'];

    function quantityService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/quantities';
        var service = {
            getQuantities: getQuantities,
            getQuantityList: getQuantityList,
            getQuantity: getQuantity,
            saveQuantity: saveQuantity,
            updateQuantity: updateQuantity,
            deleteQuantity: deleteQuantity
        }

        return service;

        function getQuantities(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getQuantityList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getQuantity(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('quantities')
                });
        }

        function saveQuantity(quantity){
            return $http.post(urlBase, quantity)
                .then(function(response){
                    messageService.register('quantities');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('quantities')
                });
        }

        function updateQuantity(quantityId, quantity){
            return $http.put(urlBase + "/" + quantityId, quantity)
                .then(function(response){
                    messageService.registerUpdate('quantities')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('quantities')
                });
        }

        function deleteQuantity(quantityId){
            return $http.delete(urlBase + "/" + quantityId)
                .then(function(response){
                    messageService.registerDelete('quantities');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('quantities');
                });
        }
    }
})();
